export default {
  BankNameTitle: '銀行名稱',
  AccountNameTitle: '賬戶名稱',
  BankAddressTitle: '銀行地址',
  SwiftTitle: 'SWIFT 代碼',

  xzSecuritiesAccTitleHK: '[證券]星展銀行賬戶號碼 (港幣)',
  zgSecuritiesAccTitleHK: '[證券]中國銀行賬戶號碼 (港幣)',
  FPSSecuritiesAccTitleHK: '[證券]轉數快（FPS）轉賬識別碼(港幣)',
  xzFuturesAccTitleHK: '[期貨]星展銀行賬戶號碼 (港幣)',
  zgFuturesAccTitleHK: '[期貨]中國銀行賬戶號碼 (港幣)',
  FPSFuturesAccTitleHK: '[期貨]轉數快（FPS）轉賬識別碼 (港幣)',
  gsForexAccTitleHK: '[外匯]中國工商銀行賬戶號碼 (港幣)',
  FPSForexAccTitleHK: '[外匯]轉數快（FPS）轉賬識別碼 (港幣)',
  gsMFAccTitleHK: '[FX Pro]中國工商銀行賬戶號碼 (港幣)',
  gsPMAccTitleHK: '[現貨黃金]中國工商銀行賬戶號碼 (港幣)',
  xzSecuritiesAccTitleUS: '[證券]星展銀行賬戶號碼 (美元)',
  zgSecuritiesAccTitleUS: '[證券]中國銀行賬戶號碼 (美元)',
  xzFuturesAccTitleUS: '[期貨]星展銀行賬戶號碼 (美元)',
  zgFuturesAccTitleUS: '[期貨]中國銀行賬戶號碼 (美元)',
  gsForexAccTitleUS: '[外匯]中國工商銀行賬戶號碼 (美元)',
  gsMFAccTitleUS: '[FX Pro]中國工商銀行賬戶號碼 (美元)',
  gsPMAccTitleUS: '[現貨黃金]中國工商銀行賬戶號碼 (美元)',
  xzSecuritiesAccTitleCN: '[證券]星展銀行賬戶號碼 (人民幣)',
  zgSecuritiesAccTitleCN: '[證券]中國銀行賬戶號碼 (人民幣)',
  xzFuturesAccTitleCN: '[期貨]星展銀行賬戶號碼 (人民幣)',
  zgFuturesAccTitleCN: '[期貨]中國銀行賬戶號碼 (人民幣)',
  gsForexAccTitleCN: '[外匯]中國工商銀行賬戶號碼 (人民幣)',
  gsMFAccTitleCN: '[FX Pro]中國工商銀行賬戶號碼 (人民幣)',
  gsPMAccTitleCN: '[現貨黃金]中國工商銀行賬戶號碼 (人民幣)',

  xzSecuritiesAccHK: '016-478-783313006',
  zgSecuritiesAccHK: '012-873-2-002063-5',
  FPSSecuritiesAccHK: '7853658',
  xzFuturesAccHK: '016-478-000324487',
  zgFuturesAccHK: '012-873-2-002064-8',
  FPSFuturesAccHK: '7025075',
  gsForexAccHK: ' 072-722-502-013475',
  FPSForexAccHK: '4009940',
  xzSecuritiesAccUS: '016-478-000677626',
  zgSecuritiesAccUS: '012-873-2-002065-1',
  xzFuturesAccUS: '016-478-000677644',
  zgFuturesAccUS: '012-873-2-002066-4',
  gsForexAccUS: ' 072-722-506-002314',
  xzSecuritiesAccCN: '016-478-000677635',
  zgSecuritiesAccCN: '012-873-2-002067-7',
  xzFuturesAccCN: '016-478-000677653',
  zgFuturesAccCN: '012-873-2-002068-0',
  gsForexAccCN: '072-722-560-002224',

  xzBankName: '星展銀行（香港）有限公司',
  zgBankName: '中國銀行（香港）有限公司',
  FPSName: '轉數快（FPS）轉賬識別碼',
  gsBankName: '中國工商銀行（亞洲）有限公司',
  zgAccountName: '艾德證券期貨有限公司 Eddid Securities and Futures Limited',
  xzAccountName: '艾德證券期貨有限公司 Eddid Securities and Futures Limited',
  gsAccountName: '艾德證券期貨有限公司 Eddid Securities and Futures Limited',
  zgBankAddress:
    '香港中環花園道一號中銀大廈Bank of China Tower, 1 Garden Road, Central, Hong Kong',
  xzBankAddress:
    '香港中環皇后大道中99號中環中心11樓11/F, The Center, 99 Queen’s Road, Central',
  gsBankAddress:
    '中環花園道3號中國工商銀行大廈 ICBC Tower, 3 Garden Road, Central, Hong Kong',
  zgSwiftCode: 'BKCHHKHHXXX',
  xzSwiftCode: 'DHBKHKHH',
  gsSwiftCode: 'UBHKHKHH',

  CurHK: 'HKD',
  CurUS: 'USD',
  CurCN: 'CNY',

  payee: '收款人姓名',
  bankNum: '銀行卡號',
  payeeNum: '收款人賬戶號碼'
}
